import { setConfiguration } from '@configuratorware/configurator-frontendgui/App/configuration';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import ConfiguratorScreen from '../Screens/ConfiguratorScreen';
import ConfiguratorService from '../Services/ConfiguratorService';
import InteractionService from '../Services/InteractionService';
import VisualizationService from '../Services/VisualizationService';

const prod = process.env.NODE_ENV === 'production';

const envDomains = {
  test: '',
  int: 'http://int.brands-teamtex.local',
  local: 'http://int.brands-teamtex.local', //'http://localhost:10820'
  prod: '',
};

const domain = envDomains[prod ? 'prod' : 'local'];

const query = new URLSearchParams(location.search);

const adminMode = query.get('_adminmode');

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}`,
    resourcesURL: `${domain}`,
  },
  screens: {
    Configurator: ConfiguratorScreen,
  },
  services: {
    ConfiguratorService,
    VisualizationService,
    InteractionService,
  },
  disableBeforeunloadWarning: true,
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader('no-cache');
}

if (query.has('_identifier')) {
  Api.setGETParameter('_identifier', encodeURIComponent(query.get('_identifier')));
}

export default customApplicationConfiguration;
